import React from 'react';
import {  BrowserRouter, HashRouter } from "react-router-dom";
import "./assets/css/index.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import "primereact/resources/themes/lara-light-indigo/theme.css";  //index
import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css"; 

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <BrowserRouter basename='/store/motor'>
      <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(////     // console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
